import { fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { RootState } from "types";

const baseUrl = process.env.REACT_APP_API_URL || 'https://api.vlemobile.com/'

export const stripePublicKey = process.env.REACT_APP_STRIPE_PUBLIC_KEY || 'pk_live_51Qu9dDGMdjalKTdrzFNKCFAnr1JgvFP7nLCvNSVBgl0AkZ5RvrTOnlV4bCG4FEK86UTCi8oWjFRHSsBcjQilGhdx00Bs7vnsZ4'


const defaultHeaders = {
  Accept: "application/json",
};

const prepareHeaders = (headers: any, { getState }) => {
  const token = (getState() as RootState)?.global?.user?.tokens?.[0]?.token;
  if (token) {
    headers.set("api-token", token);
  }
  return headers;
};
export const baseQuery = fetchBaseQuery({
  baseUrl,
  headers: defaultHeaders,
  prepareHeaders,
});

export const formatErrors = (errors: any) => {
  console.log("formatErrors", errors?.data?.messages?.[0]);
  if (errors?.data?.messages?.[0]) {
    return errors?.data?.messages?.[0];
  } else {
    return errors?.messages || "Something went wrong";
  }
};

export const transformPaginatedResponse = (data) => data?.response;

export const HTTP_METHODS = {
  GET: "GET",
  POST: "POST",
  PUT: "PUT",
  DELETE: "DELETE",
  PATCH: "PATCH",
};

export const endpoints = {
  baseUrl,
  postPlan: {
    url: "/api/plans",
    method: HTTP_METHODS.GET,
  },
  checkAvailability: {
    url: "/api/check-availability",
    method: HTTP_METHODS.POST,
  },
  deviceCompatibility: {
    url: "/api/deviceCompatibility",
    method: HTTP_METHODS.POST,
  },
  getDevices: {
    url: "/api/deviceCompatibility",
    method: HTTP_METHODS.GET,
  },
  verifyCustomer: {
    url: "/api/payment/verifyCustomer",
    method: HTTP_METHODS.POST,
  },
  validatePort: {
    url: "/api/validate-portin",
    method: HTTP_METHODS.POST,
  },
  checkSim: {
    url: "/api/payment/checkSim",
    method: HTTP_METHODS.POST,
  },
  orderSummary: {
    url: "/api/payment/payment-details",
    method: HTTP_METHODS.POST,
  },
  login: {
    url: "/auth/user/login",
    method: HTTP_METHODS.POST,
  },
  checkout: {
    url: "/api/payment/create-subscription",
    method: HTTP_METHODS.POST,
  },
  dashboard: {
    url: "/api/my-account/dashboard",
    method: HTTP_METHODS.GET,
  },
  simService: {
    url: "/api/my-account/sim-service",
    method: HTTP_METHODS.GET,
  },
  activateSim: {
    url: "/api/activate-sim",
    method: HTTP_METHODS.POST,
  },
  paymentHistory: {
    url: "/api/my-account/payment-history",
    method: HTTP_METHODS.GET,
  },
  countriesList: {
    url: "/api/my-account/list-of-countries",
    method: HTTP_METHODS.GET,
  },
  verifyOTP: {
    url: "/auth/user/verify-two-factor-auth",
    method: HTTP_METHODS.POST,
  },
  transferNumber: {
    url: "/api/portin",
    method: HTTP_METHODS.POST,
  },
  forgotPassword: {
    url: "/auth/user/forgot-password",
    method: HTTP_METHODS.POST,
  },
  resetPassword: {
    url: "/auth/user/change-password",
    method: HTTP_METHODS.POST,
  },
  verifyResetPasswordOtp: {
    url: "/auth/user/reset-password-otp",
    method: HTTP_METHODS.POST,
  },
  sendCodeToPhone: {
    url: "/auth/user/send-code",
    method: HTTP_METHODS.POST,
  },
  listOfRoamingCountries: {
    url: "/api/my-account/list-of-roamingCountries",
    method: HTTP_METHODS.GET,
  },
  getAddonPlans: {
    url: "/api/my-account/get-addon",
    method: HTTP_METHODS.GET,
  },
  getAddon: {
    url: "/my-account/get-addon",
    method: HTTP_METHODS.GET,
  },
  upgradePlan: {
    url: "/api/my-account/upgrade-plan",
    method: HTTP_METHODS.GET,
  },
  sendQrOtp: {
    url: "/api/qr/send-otp",
    method: HTTP_METHODS.POST,
  },
  verifyQrOtp: {
    url: "/api/qr/verify-otp",
    method: HTTP_METHODS.POST,
  },
  renewPlan: {
    url: "/api/qr/renew-plan",
    method: HTTP_METHODS.POST,
  },
  createAddon: {
    url: "/api/create-addon",
    method: HTTP_METHODS.POST,
  },
  buyDataTopUp: {
    url: "/api/qr/buy-data-topup",
    method: HTTP_METHODS.POST,
  },
  topupOrderSummary: {
    url: "/api/topup-order-summary",
    method: HTTP_METHODS.GET,
  },
  digitalSecurityPlans: {
    url: "/api/digital-security/plans",
    method: HTTP_METHODS.GET,
  },
  digitalSecurityOrderSummary: {
    url: "/api/digital-security/order-summary",
    method: HTTP_METHODS.GET,
  },
  digitalSecurityCreatePayment: {
    url: "/api/digital-security/create-payment",
    method: HTTP_METHODS.POST,
  },
  digitalSecurityCurrentAndUpgradePlans: {
    url: "/api/digital-security/current-and-upgrade-plans",
    method: HTTP_METHODS.GET,
  },
  getSecurityPlansOrderSummary: {
    url: "/api/digital-security/upgrade-order-summary",
    method: HTTP_METHODS.GET,
  },
  upgradeSecurityPlansCheckout: {
    url: "/api/digital-security/upgrade",
    method: HTTP_METHODS.POST,
  },
  getNewLine: {
    url: "/api/get-newline",
    method: HTTP_METHODS.GET,
  },
  viewQr: {
    url: "/api/view-qr",
    method: HTTP_METHODS.POST,
  },
  checkPortStatus: {
    url: "/api/portin-check",
    method: HTTP_METHODS.POST,
  },
  updatePortin: {
    url: "/api/update-portin",
    method: HTTP_METHODS.POST,
  },
  lockUnlockSim: {
    url: "/api/my-account/lock-unlock-sim",
    method: HTTP_METHODS.POST,
  },
  registerPSim: {
    url: "/api/my-account/register-psim",
    method: HTTP_METHODS.POST,
  },
  getProfile: {
    url: "/api/my-account/get-profile",
    method: HTTP_METHODS.GET,
  },
  updateProfile: {
    url: "/api/my-account/update-profile",
    method: HTTP_METHODS.POST,
  },
  generateBillPdf: {
    url: "/api/my-account/generate-bill-pdf",
    method: HTTP_METHODS.GET,
  },
  fileUpload: {
    url: "/api/file-upload",
    method: HTTP_METHODS.POST,
  },
  validateSim: {
    url: "/api/payment/validate-sim",
    method: HTTP_METHODS.POST,
  },
  validateDevice: {
    url: "/api/payment/validate-device",
    method: HTTP_METHODS.POST,
  },
  getUpgradedPlan: {
    url: "/api/upgrade-plan/available-plans",
    method: HTTP_METHODS.GET,
  },
  upgradePlanOrderSummary: {
    url: "/api/upgrade-plan/order-summary-after-billing-cycle",
    method: HTTP_METHODS.GET,
  },
  upgradePlanCheckout: {
    url: "/api/upgrade-plan/upgrade-after-billing-cycle",
    method: HTTP_METHODS.POST,
  },
  getPaymentMethods: {
    url: "/api/payment-methods",
    method: HTTP_METHODS.GET,
  },
  contact:{
    url:'/api/contact',
    method:HTTP_METHODS.POST,
  },
  getProducts: {
    url: "/api/products",
    method: HTTP_METHODS.GET,
  },
  getProductById: {
    url: "/api/products/:id",
    method: HTTP_METHODS.GET,
  }
};
